/* OneWear cart: three dot loader on the product image while a quantity change loads */
(function () {
  if (window.owLoaderInit) return;
  window.owLoaderInit = true;

  var DEFAULT_MS = 650;  // measured typical load time for a quantity change
  var LAPS = 1;          // loader runs exactly one full lap, paced to the load time
  var MIN_LAP = 0;       // no artificial slowdown: the request is never delayed
  var loaders = {};

  function avgLoad() {
    try { var v = parseFloat(localStorage.getItem('owLoadMs')); if (v > 150 && v < 4000) return v; } catch (e) {}
    return DEFAULT_MS;
  }
  function saveLoad(ms) {
    if (ms < 150 || ms > 4000) return;
    try { localStorage.setItem('owLoadMs', String(Math.round(avgLoad() * 0.6 + ms * 0.4))); } catch (e) {}
  }

  function css() {
    if (document.getElementById('ow-ld-css')) return;
    var s = document.createElement('style');
    s.id = 'ow-ld-css';
    s.textContent =
      '.cart-drawer line-item{position:relative}' +
      '.ow-ld{position:absolute;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:2;opacity:0;transition:opacity .2s ease}' +
      '.ow-ld.is-on{opacity:1}' +
      '.ow-ld__pill{display:flex;align-items:center;gap:4px;padding:5px 7px;background:#fff;border-radius:999px;box-shadow:0 1px 4px rgba(0,0,0,.14)}' +
      '.ow-ld__pill i{display:block;width:5px;height:5px;border-radius:50%;background:#cfcfcf;transition:background-color .22s ease,transform .22s ease}' +
      '.ow-ld__pill i.on{background:#111;transform:scale(1.15)}';
    document.head.appendChild(s);
  }

  // Line keys change with quantity, so match rows by variant id and position
  function keyOf(li) {
    var i = li.querySelector('[data-line-key]');
    if (i) return i.getAttribute('data-line-key').split(':')[0];
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }
  function lines() { return [].slice.call(document.querySelectorAll('#cart-drawer line-item')); }
  function findLine(l) {
    var all = lines();
    var hits = all.filter(function (li) { return keyOf(li) === l.key; });
    if (hits.length < 2) return hits[0] || null;
    return all[l.idx] && keyOf(all[l.idx]) === l.key ? all[l.idx] : hits[0];
  }

  function build() {
    var el = document.createElement('div');
    el.className = 'ow-ld';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="ow-ld__pill"><i></i><i></i><i></i></span>';
    return el;
  }

  // Put the loader over the row image, also after the drawer re-renders the row
  function place(l) {
    var li = findLine(l);
    if (!li) { if (l.el) l.el.remove(); return false; }
    var img = li.querySelector('.line-item__media');
    if (!img) return false;
    if (l.el.parentNode !== li) { li.appendChild(l.el); l.el.offsetWidth; }
    l.el.style.left = img.offsetLeft + 'px';
    l.el.style.top = img.offsetTop + 'px';
    l.el.style.width = img.offsetWidth + 'px';
    l.el.style.height = img.offsetHeight + 'px';
    l.el.classList.add('is-on');
    return true;
  }

  function tick() {
    var now = performance.now();
    var active = false;
    Object.keys(loaders).forEach(function (k) {
      var l = loaders[k];
      var t = now - l.start;
      if (l.end && t >= l.end) { stop(k); return; }
      active = true;
      // Hold on the last dot until the response lands
      var n = Math.floor(t / (l.lap / 3));
      n = Math.min(n, LAPS * 3 - 1);
      var step = n % 3;
      if (step !== l.step) {
        l.step = step;
        var dots = l.el.querySelectorAll('i');
        for (var i = 0; i < 3; i++) dots[i].classList.toggle('on', i === step);
      }
    });
    if (!active) { clearInterval(timer); timer = 0; }
  }
  var timer = 0;
  function loop() { if (!timer) { timer = setInterval(tick, 16); tick(); } }

  function stop(k) {
    var l = loaders[k];
    delete loaders[k];
    if (!l || !l.el) return;
    l.el.classList.remove('is-on');
    setTimeout(function () { l.el.remove(); }, 220);
  }

  function start(li) {
    css();
    var key = keyOf(li);
    if (!key) return;
    var idx = lines().indexOf(li);
    var id = key + '#' + idx;
    var old = loaders[id];
    var l = {
      key: key,
      idx: idx,
      el: old ? old.el : build(),
      start: performance.now(),
      req: performance.now(),
      lap: Math.max(avgLoad() / LAPS, MIN_LAP),
      step: -1,
      end: 0,
      done: false
    };
    loaders[id] = l;
    place(l);
    loop();
    return l;
  }

  // Request delay (always 0 now: the request goes out immediately)
  function delayFor(l) {
    return Math.max(0, LAPS * l.lap - avgLoad() - 30);
  }

  // Response landed: finish the lap, then fade out
  var settle = 0;
  function landed() {
    var now = performance.now();
    Object.keys(loaders).forEach(function (k) {
      var l = loaders[k];
      if (l.done || now - l.start < 60) return;
      l.done = true;
      var t = now - l.start;
      saveLoad(now - l.req);
      l.end = Math.max(LAPS * l.lap, t + 40);
    });
    // Move the loader to the new row now, and again once the re-render settles
    Object.keys(loaders).forEach(function (k) { if (loaders[k].done) place(loaders[k]); });
    clearTimeout(settle);
    settle = setTimeout(function () {
      Object.keys(loaders).forEach(function (k) {
        var l = loaders[k];
        if (l.done && !place(l)) stop(k);
      });
    }, 30);
  }

  function ours(n) {
    return n && n.nodeType === 1 && (n.classList.contains('ow-ld') || n.classList.contains('ow-qv') || (n.closest && n.closest('.ow-ld, .ow-qv')));
  }

  var mo = new MutationObserver(function (list) {
    if (!Object.keys(loaders).length) return;
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (ours(m.target)) continue;
      var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
      if (nodes.length && nodes.every(ours)) continue;
      landed();
      return;
    }
  });

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#cart-drawer line-item [href*="/cart/change"]');
    if (!b) return;
    if (b.dataset.owGo) { delete b.dataset.owGo; return; }
    var l = start(b.closest('line-item'));
    if (!l) return;
    var wait = delayFor(l);
    if (!wait) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    setTimeout(function () {
      if (!b.isConnected) return;
      l.req = performance.now();
      b.dataset.owGo = '1';
      b.click();
    }, wait);
  }, true);

  document.addEventListener('change', function (e) {
    var i = e.target && e.target.closest && e.target.closest('#cart-drawer line-item [data-line-key]');
    if (i) start(i.closest('line-item'));
  }, true);

  function init() {
    var dr = document.getElementById('cart-drawer');
    if (dr) mo.observe(dr, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* OneWear product page: side panel (bottom sheet on mobile) for the trust rows */
(function () {
  if (window.owSheet) return;
  var open = null;

  function close() {
    if (!open) return;
    var o = open; open = null;
    o.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { o.remove(); }, 320);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  window.owSheet = function (id) {
    var tpl = document.getElementById(id);
    if (!tpl) return;
    close();
    var wrap = document.createElement('div');
    wrap.className = 'ow-sheet';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML = '<div class="ow-sheet__backdrop" data-ow-close></div><div class="ow-sheet__panel"><button type="button" class="ow-sheet__close" data-ow-close aria-label="Close"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg></button><div class="ow-sheet__inner"></div></div>';
    wrap.querySelector('.ow-sheet__inner').appendChild(tpl.content.cloneNode(true));
    document.body.appendChild(wrap);
    wrap.addEventListener('click', function (e) { if (e.target.closest('[data-ow-close]')) close(); });
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    open = wrap;
    wrap.offsetWidth;
    wrap.classList.add('is-open');
  };
})();
